"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClearColContent = exports.handleInsertColBefore = exports.handleInsertColAfter = exports.handleDuplicateCol = exports.handleDeleteCol = exports.handleAddCol = void 0;
var genHash_1 = require("../utils/genHash");
var genNewCell = function () { return ({
    id: "cell_".concat((0, genHash_1.genHash)(8)),
}); };
var handleAddColAtIdx = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id, defaultColWidth = _a.defaultColWidth, colIdx = _a.colIdx;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    newData = newData.map(function (row) {
        var newCellData = __spreadArray([], row.cellData, true);
        newCellData.splice(colIdx, 0, genNewCell());
        return __assign(__assign({}, row), { cellData: newCellData });
    });
    var newColWidthValue = defaultColWidth + "px";
    var newColWidthConfigAsArray = Object.values(colWidthConfig);
    newColWidthConfigAsArray.splice(colIdx, 0, newColWidthValue);
    var newColWidthConfig = newColWidthConfigAsArray
        .map(function (width, i) { return ({
        colId: "col_".concat(i),
        width: width,
    }); })
        .reduce(function (a, b) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[b.colId] = b.width, _a)));
    }, {});
    onChange &&
        onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};
var handleAddCol = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id, defaultColWidth = _a.defaultColWidth;
    handleAddColAtIdx({
        value: value,
        onChange: onChange,
        id: id,
        defaultColWidth: defaultColWidth,
        colIdx: value.data[0].cellData.length,
    });
};
exports.handleAddCol = handleAddCol;
var handleDeleteCol = function (_a) {
    var value = _a.value, colIdx = _a.colIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = data.map(function (row) {
        var newCellData = row.cellData.filter(function (cell, cellIdx) { return colIdx !== cellIdx; });
        return __assign(__assign({}, row), { cellData: newCellData });
    });
    var newColWidthConfig = __assign({}, colWidthConfig);
    delete newColWidthConfig["col_".concat(colIdx)];
    // now that we deleted this colIdx from widthconfig. we need to reset all the keys from col_0 to col_<length-1>
    newColWidthConfig = Object.values(newColWidthConfig)
        .map(function (width, i) { return ({
        colId: "col_".concat(i),
        width: width,
    }); })
        .reduce(function (a, b) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[b.colId] = b.width, _a)));
    }, {});
    onChange &&
        onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};
exports.handleDeleteCol = handleDeleteCol;
var handleDuplicateCol = function (_a) {
    var value = _a.value, colIdx = _a.colIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = data.map(function (row) {
        var newCellData = __spreadArray([], row.cellData, true);
        var dataToDuplicate = __assign(__assign({}, newCellData[colIdx]), { id: "cell_".concat((0, genHash_1.genHash)(8)) });
        newCellData.splice(colIdx + 1, 0, dataToDuplicate);
        return __assign(__assign({}, row), { cellData: newCellData });
    });
    var newColWidthValue = colWidthConfig["col_".concat(colIdx)];
    var newColWidthConfigAsArray = Object.values(colWidthConfig);
    newColWidthConfigAsArray.splice(colIdx + 1, 0, newColWidthValue);
    var newColWidthConfig = newColWidthConfigAsArray
        .map(function (width, i) { return ({
        colId: "col_".concat(i),
        width: width,
    }); })
        .reduce(function (a, b) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[b.colId] = b.width, _a)));
    }, {});
    onChange &&
        onChange(id, { data: newData, colWidthConfig: newColWidthConfig });
};
exports.handleDuplicateCol = handleDuplicateCol;
var handleInsertColAfter = function (_a) {
    var value = _a.value, colIdx = _a.colIdx, onChange = _a.onChange, id = _a.id, defaultColWidth = _a.defaultColWidth;
    handleAddColAtIdx({
        value: value,
        onChange: onChange,
        id: id,
        defaultColWidth: defaultColWidth,
        colIdx: colIdx + 1,
    });
};
exports.handleInsertColAfter = handleInsertColAfter;
var handleInsertColBefore = function (_a) {
    var value = _a.value, colIdx = _a.colIdx, onChange = _a.onChange, id = _a.id, defaultColWidth = _a.defaultColWidth;
    handleAddColAtIdx({
        value: value,
        onChange: onChange,
        id: id,
        defaultColWidth: defaultColWidth,
        colIdx: colIdx,
    });
};
exports.handleInsertColBefore = handleInsertColBefore;
var handleClearColContent = function (_a) {
    var value = _a.value, colIdx = _a.colIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = data.map(function (row) {
        var newCellData = __spreadArray([], row.cellData, true);
        // let cellToClear = newCellData[colIdx];
        // delete cellToClear.value;
        // console.log({cellToClear})
        /**
         * this genNewRow does one very important thing apart from the obvious of clearing the value:
         * it creates a fresh new row id, which changes the 'react key' of the row being rendered, which
         * ensures the the RTE used within the cell is reinitiated and the previous value in it is cleared.
         * (since RTEs are not controlled components)
         */
        newCellData.splice(colIdx, 1, genNewCell());
        // console.log({newCellData})
        return __assign(__assign({}, row), { cellData: newCellData });
    });
    // console.log({newData})
    onChange &&
        onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleClearColContent = handleClearColContent;
